import * as React from "react";
const SvgClearLine = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.5 2.2168H10.5V5.2168H16.125V8.2168H1.875V5.2168H7.5V2.2168Z", stroke: "#1A1A1A", style: {
  stroke: "#1A1A1A",
  stroke: "color(display-p3 0.1020 0.1020 0.1020)",
  strokeOpacity: 1
}, strokeWidth: 1.41, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3 14.999H15V8.24902H3V14.999Z", stroke: "#1A1A1A", style: {
  stroke: "#1A1A1A",
  stroke: "color(display-p3 0.1020 0.1020 0.1020)",
  strokeOpacity: 1
}, strokeWidth: 1.41, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6 14.9609V12.7169M9 14.9609V12.7109M12 14.9609V12.7169M4.5 14.9992H13.5", stroke: "#1A1A1A", style: {
  stroke: "#1A1A1A",
  stroke: "color(display-p3 0.1020 0.1020 0.1020)",
  strokeOpacity: 1
}, strokeWidth: 1.41, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgClearLine;
